import { clsx } from "clsx";
import FullBleedSetup from "./FullBleedSetup";
import type { ToolkitActivityVariant } from "./activityVariant";
import styles from "./FullBleedScreen.module.css";

/**
 * Implementation for the full screen view pattern. Accounts for extra top and bottom
 * space necessary to avoid iPhone notch and status bar
 */
type FullBleedScreenProps = {
  // `variant` picks the activity's brand color out of `FullBleedScreen.module.css`.
  // For ad-hoc cases (e.g. a per-episode image backdrop) pass `className` instead.
  variant?: ToolkitActivityVariant;
  className?: string;
  children: React.ReactNode;
};

export default function FullBleedScreen({ variant, className, children }: FullBleedScreenProps) {
  return (
    <FullBleedSetup>
      <div className={clsx(styles.screen, variant && styles[variant], className)}>{children}</div>
    </FullBleedSetup>
  );
}
